'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);

var _ReviewSites = require('./ReviewSites.scss');var styles = _interopRequireWildcard(_ReviewSites);
var _RealtorLanding = require('../../../static/images/RealtorLanding');var _RealtorLanding2 = _interopRequireDefault(_RealtorLanding);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var ReviewSites = function ReviewSites(props) {return (
        _react2.default.createElement('div', { className: styles.wrapper },
            _react2.default.createElement('p', null, props.translate('reviewSites', 'title')),
            _react2.default.createElement('div', { className: styles.linksWrapper },
                _react2.default.createElement('a', {
                        className: styles.link,
                        href: 'https://www.calcalist.co.il/articles/0,7340,L-3838340,00.html',
                        target: '_blank',
                        rel: 'noopener noreferrer' },

                    _react2.default.createElement('img', { src: _RealtorLanding2.default.calcalist, alt: '' }),
                    _react2.default.createElement('img', { src: _RealtorLanding2.default.theMarkerSample, className: styles.tooltip, alt: '' })),

                _react2.default.createElement('a', {
                        className: styles.link,
                        href: 'https://www.themarker.com/labels/proptech/1.9948109',
                        target: '_blank',
                        rel: 'noopener noreferrer' },

                    _react2.default.createElement('img', { src: _RealtorLanding2.default.theMarker, alt: '' }),
                    _react2.default.createElement('img', { src: _RealtorLanding2.default.haaretzSample, className: styles.tooltip, alt: '' })),

                _react2.default.createElement('a', {
                        className: styles.link,
                        href: 'https://www.haaretz.co.il/labels/apps/1.9339560',
                        target: '_blank',
                        rel: 'noopener noreferrer' },

                    _react2.default.createElement('img', { src: _RealtorLanding2.default.haaretz, alt: '' }),
                    _react2.default.createElement('img', { src: _RealtorLanding2.default.calcalistSample, className: styles.tooltip, alt: '' })))));};





ReviewSites.propTypes = {
    translate: _propTypes2.default.func };exports.default =


ReviewSites;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ReviewSites/ReviewSites.js
// module id = 2847
// module chunks = 0